export const N76_01 = {
    "columns": 4,
    "rows": 1,
    "visual": {
      "id": 1,
      "type": "bar2",
      "title": "Top Items",
      "colorTheme": 'colorTheme1',
      "orientation": "horizontal",
      "xAxis": "Sales",
      "yAxis": "",
      "binding": {
        "data": {
          "series": [
            {
              "name": 'Sales',
              "value": 'ActualSales',
              "type": 'column'
            }
          ],
          "title": "ItemName",
          "endpoint": "N76.1",
          "parameters": [
            { "key": "FromMonth", "value": "" },
            { "key": "FromYear", "value": "" },
            { "key": "ToMonth", "value": "" },
            { "key": "ToYear", "value": "" },
            { "key": "ConfigTypeCode", "value": "" }
          ]
        },
        "context": {
          "point": {
            "onClick": { }
          }
        }
      }
    }
  }